<template>
  <div class="main-layout">
    <el-card class="box-form box-outter">
      <c-title slot="header" :title="'详情'"></c-title>
      <div class="div-scroll" style="width: 70%; margin: 0 auto">
        <!-- <el-row class="avatar-row" style="width: 80%; margin: 0 auto">
          <el-col :span="24">
            <c-grid v-model="teacherInfo" :gridItems="gridItems" bord></c-grid>
          </el-col>
        </el-row> -->
        <el-descriptions :column="1" border :labelStyle="{ width: '150px' }">
          <el-descriptions-item
            :label="item.label"
            v-for="(item, index) in gridItems"
            :key="index"
          >
            <span>{{ teacherInfo[item.model] }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
import Configs from "./data/teacher.js";
import { mapState } from "vuex";
export default {
  components: {
    CTitle,
  },
  data() {
    let { gridItems } = Configs(this);
    return {
      teacherInfo: {},
      gridItems,
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CARDTYPE"]),
  },
  created() {
    let id = this.$route.params.id;
    this.getTeacherInfo(id);
  },
  mounted() {},
  methods: {
    getIdCardType(data) {
      if (data) {
        let item = this._CARDTYPE.find((item) => item.value == data);
        return item.label ? item.label : "";
      }
    },
    getTeacherInfo(id) {
      this.$http.get("/account/base/teacher/" + id).then((res) => {
        if (res.code == this.SUCCESS_CODE) {
          // console.log(res);
          if (res.data) {
            this.teacherInfo = res.data;
            this.teacherInfo.idCardTypeName = this.getIdCardType(res.data.idCardType)
          }
        }
      });
    },
  },
};
</script>


